import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type Variant = 'gold' | 'outline' | 'ghost';
type Props = {
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
  variant?: Variant;
  className?: string;
  ariaLabel?: string;
};

// A restrained, premium CTA used contextually across every scene.
export function CinematicButton({
  href,
  onClick,
  children,
  variant = 'gold',
  className = '',
  ariaLabel
}: Props) {
  const base = 'group inline-flex items-center gap-2.5 rounded-full px-6 py-3 text-sm font-medium tracking-wide transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ms-gold-soft)] focus-visible:ring-offset-2 focus-visible:ring-offset-transparent';
  const variants: Record<Variant, string> = {
    gold: 'bg-[var(--ms-gold)] text-[#1a1206] hover:bg-[var(--ms-gold-soft)] shadow-[0_8px_30px_-8px_rgba(199,154,75,0.6)]',
    outline: 'border border-white/40 text-white backdrop-blur-sm hover:border-[var(--ms-gold-soft)] hover:text-[var(--ms-gold-soft)]',
    ghost: 'text-white/80 hover:text-white'
  };
  const content = <>
      <span data-id="element-184" data-mp="2omgji4zinwv4">{children}</span>
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" data-id="element-185" data-mp="2opun1gjx2c45" />
    </>;
  const cls = `${base} ${variants[variant]} ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" aria-label={ariaLabel} className={cls} data-id="element-186" data-mp="2evvmglzhr0eb">
        {content}
      </a>;
  }
  return <button type="button" onClick={onClick} aria-label={ariaLabel} className={cls} data-id="element-187" data-mp="24xo88awl6wg0">
      {content}
    </button>;
}